import RpcService from "@/core/services/Rpc/RpcService";
import RpcResponse from "@/core/services/Rpc/RpcResponse";
import type RpcDataPagination from "@/core/services/Rpc/RpcDataPagination";
import type RpcDataSort from "@/core/services/Rpc/RpcDataSort";

class CountriesDAO {

    static async getList(
      filters?: {
        countryCodes?: string[],
        pattern?: string,
        name?: string,
        nameFull?: string
      },
      pagination?: RpcDataPagination,
      sort?: RpcDataSort
    ): Promise<RpcResponse> {
        return await RpcService.makeRequest(
          'countries.getList',
          {
            ...filters,
            countryCodes: filters?.countryCodes ? filters.countryCodes : undefined,
          },
          pagination,
          sort
        );
    }
}

export default CountriesDAO;
